import { tokenAuthApiInstance } from 'utils/auth';

import { ALERT_DETAILS_ENDPOINT } from './constants';

export type AlertDetails = {
  DateSent: number;
  ExpirationDateTime: string;
  TimeZone: string;
  Locale: string;
  Message: string;
  Link: string;
  SendBy: string;
  Status: 'Sent' | 'Deleted';
};

export type AlertDetailsResponse = Array<AlertDetails>;

export const getAlertDetails = async (): Promise<AlertDetailsResponse> => {
  const response = await tokenAuthApiInstance.authAxios().get(ALERT_DETAILS_ENDPOINT);
  const { alertItems } = response.data;
  return alertItems;
};
